<crm-object-association-panel
  [id]="id"
  [name]="name"
  [objectType]="objectType"
  [associatedObject]="'Contact'"
  [customCardContent]="cardContent"
  [customHeaderContent]="headerContent"
  [createCardData]="cardFunction"
  [customActions]="customActions$ | async"
  [requiresPrimaryAssociation]="false"
  [confirmExistingPrimaryAssociations]="true"
></crm-object-association-panel>

<ng-template #headerContent let-card="card">
  @if (card.email) {
    <div class="card-contents email">
      <a href="mailto:{{ card.email }}" target="_blank" rel="noopener" (click)="openMailWindow(card.email)">
        {{ card.email }}
      </a>
      <button mat-icon-button (click)="copyToClipboard(card.email)" class="custom-icon-button">
        <mat-icon class="copy-icon" inline>content_copy</mat-icon>
      </button>
    </div>
  }
</ng-template>

<ng-template #cardContent let-card="card">
  @if (card.jobTitle) {
    <crm-common-association-card-content [iconName]="'person'">
      <mat-card-subtitle class="job-title">
        {{ card.jobTitle }}
      </mat-card-subtitle>
    </crm-common-association-card-content>
  }
  @if (card.linkedInUrl) {
    <crm-common-association-card-content [iconName]="'linkedin'" [isSvgIcon]="true">
      <mat-card-subtitle>
        <a class="linkedin-url-link" href="{{ card.linkedInUrl }}" target="_blank">
          {{ card.linkedInUrl }}
        </a>
      </mat-card-subtitle>
    </crm-common-association-card-content>
  }
  @if (card.phone) {
    <crm-common-association-card-content [iconName]="'phone'">
      <mat-card-subtitle>
        <a href="tel:{{ card.phone }}">
          {{ card.phone }}
        </a>
      </mat-card-subtitle>
    </crm-common-association-card-content>
  }
  <crm-common-association-card-content [iconName]="'store'">
    <app-crm-access-business-app
      [companyId]="id"
      [contactId]="card.objectId"
      [contactName]="card.name"
      [companyName]="name"
      [hasAccess]="card.businessAppAccess.hasBusinessAppAccess$ | async"
      [desiredAccess$$]="card.businessAppAccess.desiredBusinessAppAccess$$"
    ></app-crm-access-business-app>
  </crm-common-association-card-content>
</ng-template>
